module.exports = __webpack_public_path__ + "img/Graph-4.2629012e.svg";